import React, { useState } from "react"
import ordinal from "ordinal"

import "./CountryCardRanks.scss"
import InlineButtons from "../InlineButtons"
import CountryFactorBarGraph from "../CountryFactorBarGraph/"

export default function CountryCardRanks(props) {
  const [selectedRankAttribute, setRankAttribute] = useState("Global")
  const {
    selectedCountry,
    selectedYear,
    selectedFactor,
    factorSelected,
    countryData,
    scoreKey,
  } = props

  const rank = ordinal(countryData[`${scoreKey}_Rank_Global`])
  const rankCount = countryData.Count_Global
  const title = `${selectedCountry} Ranked ${rank} Across ${rankCount} Countries, ${selectedYear}`
  const graphTitle = factorSelected ? selectedFactor : "Overall Score"
  return (
    <div className="countryCard countryCardRanks">
      <div className="title fontTitle">
        <a
          name="rank"
          className="cardAnchor"
          href="#rank"
          aria-hidden="true"
          tabIndex={-1}
        />
        {title}
      </div>
      <div className="rankHeader">
        <div className="rankDescription">
          Compare {selectedYear} score rankings for {selectedCountry} by
          toggling between global, {countryData.Region} regional peers, and{" "}
          {countryData["Income Group"]} income peers.
        </div>
        <div className="rankControls">
          <InlineButtons
            value={selectedRankAttribute}
            setValue={setRankAttribute}
            options={["Global", "Region", "Income Group"]}
          />
        </div>
      </div>
      <div className="rankGraph">
        <CountryFactorBarGraph
          {...props}
          title={graphTitle}
          rankAttribute={selectedRankAttribute}
        />
      </div>
    </div>
  )
}
